const baseUrl = import.meta.env.BASE_URL || '/';
const baseNormalized = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;

export const flightChangesEmptyStateUrl = `${baseNormalized}assets/pics/flight-changes-empty-state.svg`;
export const flightChangesErrorStateUrl = `${baseNormalized}assets/pics/flight-changes-error-state.svg`;
